import { Vue as _Vue } from 'vue/types/vue';
import { VueModule } from 'vue-modules';
import VueRouter from 'vue-router';
import { Store } from 'vuex';
import { createSiteRoutes } from './router/site-router';

export class SiteModule implements VueModule {
  public readonly name = 'site';
  constructor(private router: VueRouter, private store: Store<any>) {}

  public install(Vue: typeof _Vue) {
    const routes = createSiteRoutes(this.store);
    this.router.addRoutes(routes);
  }
}
